import { useTranslation } from 'react-i18next'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'
import RoutesTabs from '~/shared/ui/RoutesTabs'
import { useConfigTabs } from './useConfigTabs'

function TaxiparkPage() {
  const { t } = useTranslation()
  const configTabs = useConfigTabs()

  return (
    <PageContainer title={t('taxipark')}>
      <RoutesTabs
        parentPath='/taxipark'
        config={configTabs}
        parentContent={
          <Container isHeader>
            <PageTitle>{t('settings')}</PageTitle>
          </Container>
        }
      />
    </PageContainer>
  )
}

export default TaxiparkPage
